<div class="ng-content card__header">
  <ng-content select="[cardHeader]" />
</div>

<div class="ng-content card__content">
  <ng-content select="[cardContent]" />
</div>

<div class="ng-content card__actions">
  <ng-content select="[cardActions]" />
</div>
